import React, { Component } from "react";
import { connect } from "react-redux";
import * as profileActions from "../../../_actions/profileActions";
import GridGallery from "react-grid-gallery";
import { map } from "lodash";
import getMemberGalleryImages from "../../../_selectors/profileSelectors/getMemberGalleryImages";

class Images extends Component {
  componentDidMount() {
    const {
      getImages,
      history,
      match,
      updateHeader,
      updateBreadcrumb
    } = this.props;
    updateHeader({
      title: "Gallery",
      description: "Place to find your special one"
    });
    updateBreadcrumb([
      { label: "Home", link: "/" },
      { label: "Profile", link: "/profile" }
    ]);
    const onError = () => {
      history.push("/");
    };
    this.unsubscribe = getImages({
      profileId: match.params.profileId,
      onError
    });
  }
  componentWillUnmount() {
    this.unsubscribe();
  }
  render() {
    const { images } = this.props;
    return (
      <div className="wrapper">
        <div className="row row-wider">
          <div className="col-sm-12">
            <GridGallery
              enableImageSelection={false}
              images={images}
              backdropClosesModal={true}
            />
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  images: getMemberGalleryImages(state)
});

const mapDispatchToProps = dispatch => ({
  getImages: payload => dispatch(profileActions.getMemberGalleryImages(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Images);



// WEBPACK FOOTER //
// ./src/_components/ViewProfile/Images/index.js